import { Pipe, PipeTransform } from '@angular/core';

// This is required because IE doesn't support padEnd()
function pad(string, max) {
  return string.length < max ? pad(string + '0', max) : string;
}

@Pipe({
  name: 'decimalPart'
})
export class DecimalPart implements PipeTransform {

  decimalPart = '';

  transform(balance: string) {

    if (balance) {
      const balanceArray: string[] = balance.split('.');
      if (balanceArray.length > 1) {
        this.decimalPart = balanceArray[1];
      }
      this.decimalPart = pad(this.decimalPart, 2);
    }

    return this.decimalPart;
  }
}


